import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "app",
  "data-bs-theme": "light"
}
const _hoisted_2 = { class: "main-content" }

import AppNavBar from '@/components/AppNavBar.vue';
import AppFooter from '@/components/AppFooter.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createVNode(AppNavBar)
    ]),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_router_view)
    ]),
    _createElementVNode("footer", null, [
      _createVNode(AppFooter)
    ])
  ]))
}
}

})